module.exports = __webpack_public_path__ + "h5/img/global_oz.47b554e1.jpg";